import {Paths} from "../../models/Paths";
import {PageTitle} from "../../components/Common/PageTitle/PageTitle";
import {Alert} from "antd";
import "./NewPractice.css"
import {PracticesHttpService} from "../../services/Http/PracticesHttpService";
import {PracticeToSave} from "../../models/Practice/PracticeToSave";
import {useEffect, useState} from "react";
import {isNil} from "lodash";
import {useTranslation} from "react-i18next";
import {AuthService} from "../../services/AuthService";
import {AppUser} from "../../models/Auth/AppUser";
import {useNavigate} from "react-router-dom";
import {NewPracticeForm, NewPracticeFormBody} from "../../components/NewPractice/NewPracticeForm";
import {NotificationService} from "../../services/NotificationService";
import {useGetInsuranceProvidersQuery} from "../../store/states/InsuranceProvidersState";
import {InsuranceProviderEclaim} from "../../models/InsuranceProvider";
import {InsuranceProviderAuthorizationHttpService} from "../../services/Http/InsuranceProviderAuthorizationHttpService";
import {InsuranceProviderAuthorizationOperationType} from "../../models/InsuranceProviderAuthorization";

export function NewPractice() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [appUser, setAppUser] = useState<AppUser | null>(AuthService.getUser());
    const [saving, setSaving] = useState<boolean>(false);
    const [allowedInsuranceProvidersForCreation, setAllowedInsuranceProvidersForCreation] = useState<string[]>([]);
    const {data: insuranceProviders} = useGetInsuranceProvidersQuery([]);

    useEffect(() => {
        if (!insuranceProviders) return;
        InsuranceProviderAuthorizationHttpService.getIdsByOperationType(InsuranceProviderAuthorizationOperationType.ALLOWED_FOR_PRACTICE_CREATION)
            .then(res => {
                const integrationCodes = (insuranceProviders as InsuranceProviderEclaim[])
                    .filter(ip => res.data.includes(ip.id))
                    .map(ip => ip.integrationCode);
                setAllowedInsuranceProvidersForCreation(integrationCodes);
            })
            .catch(() => setAllowedInsuranceProvidersForCreation([]));
    }, [insuranceProviders]);

    const initialValues = {
        locationCode: appUser?.defaultLocation?.code || null
    }

    const savePractice = async (data: NewPracticeFormBody) => {
        const body: PracticeToSave = Object.assign({}, data);
        if(isNil(appUser?.defaultLocation) === false && appUser?.defaultLocation?.code){
            body.locationCode = appUser?.defaultLocation?.code;
        }
        try {
            setSaving(true);
            const response = await PracticesHttpService.savePractice(body)
            const newClaimId = response.data;
            navigate(`/practices/details/${newClaimId}`)
        } catch (err) {
            console.error("error while creating new claim", err);
            NotificationService.getInstance().openNotificationError("Impossibile completare l'operazione")
        } finally {
            setSaving(false);
        }
    }

    return <>
        <PageTitle title={"Nuova Pratica"} backTo={Paths.HOME}></PageTitle>
        <Alert message={t("checkThePractices")} type="warning" />

        <NewPracticeForm initialValues={initialValues}
                         onSubmit={savePractice} saving={saving}
                         allowedInsuranceProviders={allowedInsuranceProvidersForCreation}/>
    </>
}
